var _circle, _rect, _rect2, _rect3, _rect4, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInHouseDeal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.5,
    r: 17.5,
    fill: "#EEEEEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 15.0048,
    y: 12.627,
    width: 1.96402,
    height: 1.73496,
    fill: "#1E2023"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 15.0048,
    y: 17.2539,
    width: 1.96402,
    height: 1.73496,
    fill: "#1E2023"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 18.3717,
    y: 12.627,
    width: 1.96402,
    height: 1.73496,
    fill: "#1E2023"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 18.3717,
    y: 17.2539,
    width: 1.96402,
    height: 1.73496,
    fill: "#1E2023"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11096_13921)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5655 14.8328H20.2449C20.4463 14.8328 20.6095 14.6646 20.6095 14.4571V12.7234C20.6095 12.5159 20.4463 12.3477 20.2449 12.3477H18.5655C18.3641 12.3477 18.2009 12.5159 18.2009 12.7234V14.4571C18.2009 14.6646 18.3641 14.8328 18.5655 14.8328ZM18.93 13.0991H19.8803V14.0814H18.93V13.0991Z",
    fill: "#1E2023"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2578 14.8328H16.9372C17.1385 14.8328 17.3017 14.6646 17.3017 14.4571V12.7234C17.3017 12.5159 17.1385 12.3477 16.9372 12.3477H15.2578C15.0564 12.3477 14.8932 12.5159 14.8932 12.7234V14.4571C14.8932 14.6646 15.0564 14.8328 15.2578 14.8328ZM15.6223 13.0991H16.5726V14.0814H15.6223V13.0991Z",
    fill: "#1E2023"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5655 19.575H20.2449C20.4463 19.575 20.6095 19.4068 20.6095 19.1993V17.4656C20.6095 17.258 20.4463 17.0898 20.2449 17.0898H18.5655C18.3641 17.0898 18.2009 17.258 18.2009 17.4656V19.1993C18.2009 19.4068 18.3641 19.575 18.5655 19.575ZM18.93 17.8413H19.8803V18.8236H18.93V17.8413Z",
    fill: "#1E2023"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9372 19.575C17.1385 19.575 17.3017 19.4068 17.3017 19.1993V17.4656C17.3017 17.258 17.1385 17.0898 16.9372 17.0898H15.2578C15.0564 17.0898 14.8932 17.258 14.8932 17.4656V19.1993C14.8932 19.4068 15.0564 19.575 15.2578 19.575H16.9372ZM15.6223 17.8413H16.5726V18.8236H15.6223V17.8413Z",
    fill: "#1E2023"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2007 26.4854H24.8617V15.1367C24.8617 14.9292 24.6985 14.761 24.4972 14.761H22.122V10.1024C22.122 9.89491 21.9587 9.7267 21.7574 9.7267H20.9807V8.37572C20.9807 8.16821 20.8174 8 20.6161 8H14.8863C14.685 8 14.5218 8.16821 14.5218 8.37572V9.7267H13.7451C13.5437 9.7267 13.3805 9.89491 13.3805 10.1024V17.3336H11.3802C11.1789 17.3336 11.0157 17.5018 11.0157 17.7093V26.4854H10.0385C9.83717 26.4854 9.67395 26.6536 9.67395 26.8611C9.67395 27.0686 9.83717 27.2368 10.0385 27.2368H25.2007C25.402 27.2368 25.5653 27.0686 25.5653 26.8611C25.5653 26.6536 25.402 26.4854 25.2007 26.4854ZM15.2509 8.75144H20.2515V9.7267H15.2509L15.2509 8.75144ZM11.7448 18.085H13.3805V26.4854H11.7448V18.085ZM14.1096 10.4781H21.3928V26.4854H19.578V23.139C19.578 22.9315 19.4148 22.7633 19.2135 22.7633H16.289C16.0876 22.7633 15.9244 22.9315 15.9244 23.139V26.4854H14.1096L14.1096 10.4781ZM16.6815 26.5695V23.6779H18.9261V26.5695H16.6815ZM22.122 26.4854V15.5124H24.1326V26.4854H22.122Z",
    fill: "#1E2023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11096_13921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8913,
    height: 19.2368,
    fill: "white",
    transform: "translate(9.67395 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInHouseDeal);
export default __webpack_public_path__ + "static/media/in-house-deal.fac19621189fc2b541dc3eecc3370f84.svg";
export { ForwardRef as ReactComponent };